"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.loadCandidates = loadCandidates;
const schema_1 = require("@kalkulacka-one/schema");
const utilities_1 = require("../utilities/index.js");
const fetch_file_1 = require("./fetch-file");
const url_builders_1 = require("./url-builders");
async function loadCandidates({ endpoint, key, group }) {
    const data = await (0, fetch_file_1.fetchFile)({ url: (0, url_builders_1.buildDataUrl)({ endpoint, key, group, resourcePath: "candidates.json" }) });
    return (0, utilities_1.parseWithSchema)({ data, schema: schema_1.candidatesSchema });
}
